import React, { useContext, useRef } from 'react';

import { Context } from '@store/store';
import useClickOutside from '@utils/useClickOutside';

import {
  StyledTOCSidebar,
  StyledTOCList,
  StyledListItem,
  StyledListItemOnActive,
  StyledBookTitle,
  StyledBookAuthors,
  StyledLine,
} from './toc-sidebar.styles';

const TOCSidebar = ({ toc, bookTitle, bookAuthors }) => {
  const [state, dispatch] = useContext(Context);
  const wrapperRef = useRef(null);
  useClickOutside(wrapperRef, 'sidebar');

  const generateTOCList = tocArray => {
    return tocArray.map((tocElement, index) => {
      const page = parseInt(tocElement.href.slice(3), 16);
      const pageToGoTo = page - 1;
      const itemList =
        pageToGoTo === state.currentPage ? (
          <StyledListItemOnActive key={`inner_list_${index}`}>
            {tocElement.text}
          </StyledListItemOnActive>
        ) : (
          <StyledListItem
            key={`inner_list_${index}`}
            onClick={() =>
              dispatch({
                type: 'SET_CURRENT_PAGE',
                payload: pageToGoTo,
              })
            }
          >
            {tocElement.text}
          </StyledListItem>
        );
      return tocElement.children ? (
        <React.Fragment key={index}>
          {itemList}
          <StyledTOCList>{generateTOCList(tocElement.children)}</StyledTOCList>
        </React.Fragment>
      ) : (
        itemList
      );
    });
  };

  return (
    <StyledTOCSidebar
      isOpened={state.isTOCSidebarOpened}
      data-is-opened={state.isTOCSidebarOpened}
      sidebarWidth={state.sidebarWidth}
      ref={wrapperRef}
    >
      {bookTitle.split(/<\/*br\s*\/*>/).map((element) => <StyledBookTitle>{element}</StyledBookTitle>)}
      <StyledBookAuthors>{bookAuthors}</StyledBookAuthors>
      <StyledLine />
      {toc ? (
        <>
          <StyledTOCList>{generateTOCList(JSON.parse(toc))}</StyledTOCList>
        </>
      ) : (
        <p>К сожалению, оглавление для данного документа отсутствует.</p>
      )}
    </StyledTOCSidebar>
  );
};

export default TOCSidebar;
